(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fom-bday-strip-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openForm(banner) {
      var id = banner.getAttribute('data-form-id');
      if (!id) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', id]);
    }

    // Delegated so it works for every instance and survives editor re-renders.
    document.addEventListener('click', function (event) {
      var banner = event.target.closest('[data-fom-strip-banner]');
      if (banner) openForm(banner);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      var banner = event.target.closest('[data-fom-strip-banner]');
      if (banner) {
        event.preventDefault();
        openForm(banner);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-story"] && !Shopify.designMode) return;
  try {
    
  customElements.define('fom-story-rail', class extends HTMLElement {
    connectedCallback() {
      this.resizeObserver = new ResizeObserver(() => {
        const button = this.closest('.fom-story').querySelector('.fom-story__next');
        if (button) button.hidden = this.scrollWidth <= this.clientWidth + 1;
      });
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.fom-story__next');
    if (!button) return;
    const rail = button.closest('.fom-story').querySelector('.fom-story__rail');
    const step = rail.firstElementChild.getBoundingClientRect().width + 5;
    const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
    rail.scrollTo({ left: atEnd ? 0 : rail.scrollLeft + step });
  });

  } catch(e) { console.error(e); }
})();
})();
